import PropTypes from 'prop-types'

export enum FieldSize {
  DEFAULT = 'DEFAULT',
  SMALL = 'SMALL'
}

export default FieldSize

export const fieldSizePropTypes = {
  size: PropTypes.oneOf(['DEFAULT', 'SMALL']),
}

export const fieldSizeDefaultProps = {
  size: 'DEFAULT',
}
